module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-halloween-left-84fc8849df23e3901dfd41b286d50b33.svg";